import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Sparkles, Loader2, Smile } from "lucide-react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

const IDEAS = ["dancing taco 🌮", "sleepy cat", "rocket cat", "melting brain", "pixel heart", "boba tea", "gremlin mood", "sparkly mushroom"];

export function EmojiDialog({ open, onClose, onCreate }) {
  const [prompt, setPrompt] = useState("");
  const [busy, setBusy] = useState(false);

  const generate = async (text) => {
    const word = (text ?? prompt).trim();
    if (!word) return;
    setBusy(true);
    try {
      await onCreate(word);
      toast.success("Sticker pinned to your board!");
      setPrompt("");
      onClose();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Could not create that emoji");
    }
    setBusy(false);
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="emoji-dialog" className="max-w-md bg-[#fbf6ec] grain">
        <DialogHeader>
          <DialogTitle className="font-display font-black text-xl text-[#2b2620] flex items-center gap-2"><Smile className="w-5 h-5 text-[#ff3b30]" /> Make an emoji sticker</DialogTitle>
        </DialogHeader>
        <p className="text-sm text-[#6b6155] -mt-2">Type anything — we'll generate a fresh, fun emoji-style sticker and pin it to your board.</p>
        <div className="space-y-3 mt-2">
          <Input
            data-testid="emoji-prompt"
            autoFocus
            placeholder="e.g. cat wearing sunglasses"
            value={prompt}
            onChange={(e) => setPrompt(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && !busy && generate()}
            className="bg-white"
          />
          <div className="flex flex-wrap gap-1.5">
            {IDEAS.map((i) => (
              <button key={i} data-testid={`emoji-idea-${i.replace(/[^a-z0-9]+/gi, "-").replace(/-+$/,"")}`} disabled={busy} onClick={() => { setPrompt(i); generate(i); }}
                className="rounded-full bg-white/80 hover:bg-white border border-[#e6dcc8] text-xs font-display font-bold text-[#4a4238] px-2.5 py-1 disabled:opacity-50">
                {i}
              </button>
            ))}
          </div>
          <Button data-testid="emoji-generate" onClick={() => generate()} disabled={busy || !prompt.trim()} className="w-full rounded-full bg-[#ff3b30] hover:bg-[#e0271d] text-white font-display font-bold">
            {busy ? <><Loader2 className="w-4 h-4 mr-1 animate-spin" /> Creating…</> : <><Sparkles className="w-4 h-4 mr-1" /> Create &amp; pin</>}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
